// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query"

import { client } from "../client.gen"
import {
  abortFileUpload,
  addConnectorConnection,
  appendTelemetry,
  cancelAgentRun,
  cancelWorkflowIntervention,
  cancelWorkflowRun,
  completeFileUpload,
  countObjects,
  createAgentThread,
  createAiLimitPolicy,
  createAuthInvitation,
  createAuthPersonalAccessToken,
  createAuthServiceAccount,
  createAuthServiceAccountAccessToken,
  createDeviceAuthorization,
  createFileUpload,
  deleteAiLimitPolicy,
  disableAuthServiceAccount,
  disconnectConnectorConnection,
  exchangeDeviceAuthorization,
  exchangeSharedAccess,
  existsObjects,
  facetObjects,
  getAction,
  getActionRun,
  getActionRunFileContent,
  getAgent,
  getAgentMessageFileContent,
  getAgentRun,
  getAgentThread,
  getAiAccountingOverview,
  getAiLimitStatus,
  getAiLimitSubjectOptions,
  getAuthAccessManagementOptions,
  getAuthInvitationOptions,
  getAuthMembershipOptions,
  getAuthSession,
  getBulkTelemetryHistory,
  getConnector,
  getConnectorConnectionRun,
  getDataset,
  getDatasetVersion,
  getLatestTelemetry,
  getObject,
  getObjectFileContent,
  getObjectType,
  getPipeline,
  getPipelineRun,
  getProjectInfo,
  getProjection,
  getProjectionRun,
  getRule,
  getSharedAccessSession,
  getStatus,
  getSync,
  getTelemetryHistory,
  getWorkflow,
  getWorkflowAgentNodeExecution,
  getWorkflowIntervention,
  getWorkflowNodeRunFileContent,
  getWorkflowRun,
  getWorkflowRunFileContent,
  issueSharedAccessGrant,
  listActionRuns,
  listActions,
  listAgentThreadMessages,
  listAgentThreadRuns,
  listAgentThreads,
  listAiLimitPolicies,
  listAiModelCallGroups,
  listAiModelCalls,
  listAuthAccessTokens,
  listAuthInvitations,
  listAuthMembers,
  listAuthServiceAccountAccessTokens,
  listAuthServiceAccounts,
  listAuthSessions,
  listConnectorConnections,
  listConnectors,
  listDatasetRows,
  listDatasets,
  listDatasetVersions,
  listEvents,
  listLogs,
  listModels,
  listObjects,
  listObjectTypes,
  listPendingConnectorConnectionRuns,
  listPipelineRuns,
  listPipelines,
  listProjectionRuns,
  listProjections,
  listRuleStates,
  listRules,
  listSharedAccessGrants,
  listSyncRuns,
  listSyncs,
  listWebhookRuns,
  listWorkflowInterventions,
  listWorkflowRuns,
  listWorkflows,
  type Options,
  postAgentThreadMessage,
  queryObjectLinks,
  queryObjects,
  reactivateAuthMember,
  reauthorizeConnectorConnection,
  recreateAgentThreadSandbox,
  refreshAuthSession,
  removeObjectLink,
  requestAction,
  requestPipelineRun,
  requestSyncRun,
  requestWorkflowRun,
  retryAgentRun,
  revokeAuthAccessToken,
  revokeAuthInvitation,
  revokeAuthServiceAccountAccessToken,
  revokeAuthSession,
  revokeConnectorConnection,
  revokeSharedAccessGrant,
  searchObjects,
  selectConnectorConnectionRunAccount,
  signFileUploadPart,
  signOut,
  signOutAll,
  signOutSharedAccess,
  startConnectorConnectionRun,
  submitWorkflowIntervention,
  suspendAuthMember,
  updateAiLimitPolicy,
  updateAuthMemberGroups,
  uploadFileContent,
  uploadFileRaw,
  upsertObject,
  upsertObjectLink,
} from "../sdk.gen"
import type {
  AbortFileUploadData,
  AbortFileUploadError,
  AbortFileUploadResponse,
  AddConnectorConnectionData,
  AddConnectorConnectionError,
  AddConnectorConnectionResponse,
  AppendTelemetryData,
  AppendTelemetryError,
  AppendTelemetryResponse,
  CancelAgentRunData,
  CancelAgentRunError,
  CancelAgentRunResponse,
  CancelWorkflowInterventionData,
  CancelWorkflowInterventionError,
  CancelWorkflowInterventionResponse,
  CancelWorkflowRunData,
  CancelWorkflowRunError,
  CancelWorkflowRunResponse,
  CompleteFileUploadData,
  CompleteFileUploadError,
  CompleteFileUploadResponse,
  CountObjectsData,
  CountObjectsError,
  CountObjectsResponse,
  CreateAgentThreadData,
  CreateAgentThreadError,
  CreateAgentThreadResponse,
  CreateAiLimitPolicyData,
  CreateAiLimitPolicyError,
  CreateAiLimitPolicyResponse,
  CreateAuthInvitationData,
  CreateAuthInvitationError,
  CreateAuthInvitationResponse,
  CreateAuthPersonalAccessTokenData,
  CreateAuthPersonalAccessTokenError,
  CreateAuthPersonalAccessTokenResponse,
  CreateAuthServiceAccountAccessTokenData,
  CreateAuthServiceAccountAccessTokenError,
  CreateAuthServiceAccountAccessTokenResponse,
  CreateAuthServiceAccountData,
  CreateAuthServiceAccountError,
  CreateAuthServiceAccountResponse,
  CreateDeviceAuthorizationData,
  CreateDeviceAuthorizationError,
  CreateDeviceAuthorizationResponse,
  CreateFileUploadData,
  CreateFileUploadError,
  CreateFileUploadResponse,
  DeleteAiLimitPolicyData,
  DeleteAiLimitPolicyError,
  DeleteAiLimitPolicyResponse,
  DisableAuthServiceAccountData,
  DisableAuthServiceAccountError,
  DisableAuthServiceAccountResponse,
  DisconnectConnectorConnectionData,
  DisconnectConnectorConnectionError,
  DisconnectConnectorConnectionResponse,
  ExchangeDeviceAuthorizationData,
  ExchangeDeviceAuthorizationResponse,
  ExchangeSharedAccessData,
  ExchangeSharedAccessError,
  ExchangeSharedAccessResponse,
  ExistsObjectsData,
  ExistsObjectsError,
  ExistsObjectsResponse,
  FacetObjectsData,
  FacetObjectsError,
  FacetObjectsResponse,
  GetActionData,
  GetActionError,
  GetActionResponse,
  GetActionRunData,
  GetActionRunError,
  GetActionRunFileContentData,
  GetActionRunFileContentError,
  GetActionRunFileContentResponse,
  GetActionRunResponse,
  GetAgentData,
  GetAgentError,
  GetAgentMessageFileContentData,
  GetAgentMessageFileContentError,
  GetAgentMessageFileContentResponse,
  GetAgentResponse,
  GetAgentRunData,
  GetAgentRunError,
  GetAgentRunResponse,
  GetAgentThreadData,
  GetAgentThreadError,
  GetAgentThreadResponse,
  GetAiAccountingOverviewData,
  GetAiAccountingOverviewError,
  GetAiAccountingOverviewResponse,
  GetAiLimitStatusData,
  GetAiLimitStatusError,
  GetAiLimitStatusResponse,
  GetAiLimitSubjectOptionsData,
  GetAiLimitSubjectOptionsError,
  GetAiLimitSubjectOptionsResponse,
  GetAuthAccessManagementOptionsData,
  GetAuthAccessManagementOptionsError,
  GetAuthAccessManagementOptionsResponse,
  GetAuthInvitationOptionsData,
  GetAuthInvitationOptionsError,
  GetAuthInvitationOptionsResponse,
  GetAuthMembershipOptionsData,
  GetAuthMembershipOptionsError,
  GetAuthMembershipOptionsResponse,
  GetAuthSessionData,
  GetAuthSessionResponse,
  GetBulkTelemetryHistoryData,
  GetBulkTelemetryHistoryError,
  GetBulkTelemetryHistoryResponse,
  GetConnectorConnectionRunData,
  GetConnectorConnectionRunError,
  GetConnectorConnectionRunResponse,
  GetConnectorData,
  GetConnectorError,
  GetConnectorResponse,
  GetDatasetData,
  GetDatasetError,
  GetDatasetResponse,
  GetDatasetVersionData,
  GetDatasetVersionError,
  GetDatasetVersionResponse,
  GetLatestTelemetryData,
  GetLatestTelemetryError,
  GetLatestTelemetryResponse,
  GetObjectData,
  GetObjectError,
  GetObjectFileContentData,
  GetObjectFileContentError,
  GetObjectFileContentResponse,
  GetObjectResponse,
  GetObjectTypeData,
  GetObjectTypeError,
  GetObjectTypeResponse,
  GetPipelineData,
  GetPipelineError,
  GetPipelineResponse,
  GetPipelineRunData,
  GetPipelineRunError,
  GetPipelineRunResponse,
  GetProjectInfoData,
  GetProjectInfoResponse,
  GetProjectionData,
  GetProjectionError,
  GetProjectionResponse,
  GetProjectionRunData,
  GetProjectionRunError,
  GetProjectionRunResponse,
  GetRuleData,
  GetRuleError,
  GetRuleResponse,
  GetSharedAccessSessionData,
  GetSharedAccessSessionError,
  GetSharedAccessSessionResponse,
  GetStatusData,
  GetStatusResponse,
  GetSyncData,
  GetSyncError,
  GetSyncResponse,
  GetTelemetryHistoryData,
  GetTelemetryHistoryError,
  GetTelemetryHistoryResponse,
  GetWorkflowAgentNodeExecutionData,
  GetWorkflowAgentNodeExecutionError,
  GetWorkflowAgentNodeExecutionResponse,
  GetWorkflowData,
  GetWorkflowError,
  GetWorkflowInterventionData,
  GetWorkflowInterventionError,
  GetWorkflowInterventionResponse,
  GetWorkflowNodeRunFileContentData,
  GetWorkflowNodeRunFileContentError,
  GetWorkflowNodeRunFileContentResponse,
  GetWorkflowResponse,
  GetWorkflowRunData,
  GetWorkflowRunError,
  GetWorkflowRunFileContentData,
  GetWorkflowRunFileContentError,
  GetWorkflowRunFileContentResponse,
  GetWorkflowRunResponse,
  IssueSharedAccessGrantData,
  IssueSharedAccessGrantError,
  IssueSharedAccessGrantResponse,
  ListActionRunsData,
  ListActionRunsError,
  ListActionRunsResponse,
  ListActionsData,
  ListActionsResponse,
  ListAgentThreadMessagesData,
  ListAgentThreadMessagesError,
  ListAgentThreadMessagesResponse,
  ListAgentThreadRunsData,
  ListAgentThreadRunsError,
  ListAgentThreadRunsResponse,
  ListAgentThreadsData,
  ListAgentThreadsError,
  ListAgentThreadsResponse,
  ListAiLimitPoliciesData,
  ListAiLimitPoliciesError,
  ListAiLimitPoliciesResponse,
  ListAiModelCallGroupsData,
  ListAiModelCallGroupsError,
  ListAiModelCallGroupsResponse,
  ListAiModelCallsData,
  ListAiModelCallsError,
  ListAiModelCallsResponse,
  ListAuthAccessTokensData,
  ListAuthAccessTokensError,
  ListAuthAccessTokensResponse,
  ListAuthInvitationsData,
  ListAuthInvitationsError,
  ListAuthInvitationsResponse,
  ListAuthMembersData,
  ListAuthMembersError,
  ListAuthMembersResponse,
  ListAuthServiceAccountAccessTokensData,
  ListAuthServiceAccountAccessTokensError,
  ListAuthServiceAccountAccessTokensResponse,
  ListAuthServiceAccountsData,
  ListAuthServiceAccountsError,
  ListAuthServiceAccountsResponse,
  ListAuthSessionsData,
  ListAuthSessionsError,
  ListAuthSessionsResponse,
  ListConnectorConnectionsData,
  ListConnectorConnectionsError,
  ListConnectorConnectionsResponse,
  ListConnectorsData,
  ListConnectorsResponse,
  ListDatasetRowsData,
  ListDatasetRowsError,
  ListDatasetRowsResponse,
  ListDatasetsData,
  ListDatasetsError,
  ListDatasetsResponse,
  ListDatasetVersionsData,
  ListDatasetVersionsError,
  ListDatasetVersionsResponse,
  ListEventsData,
  ListEventsError,
  ListEventsResponse,
  ListLogsData,
  ListLogsError,
  ListLogsResponse,
  ListModelsData,
  ListModelsResponse,
  ListObjectsData,
  ListObjectsError,
  ListObjectsResponse,
  ListObjectTypesData,
  ListObjectTypesResponse,
  ListPendingConnectorConnectionRunsData,
  ListPendingConnectorConnectionRunsError,
  ListPendingConnectorConnectionRunsResponse,
  ListPipelineRunsData,
  ListPipelineRunsError,
  ListPipelineRunsResponse,
  ListPipelinesData,
  ListPipelinesResponse,
  ListProjectionRunsData,
  ListProjectionRunsError,
  ListProjectionRunsResponse,
  ListProjectionsData,
  ListProjectionsResponse,
  ListRuleStatesData,
  ListRuleStatesError,
  ListRuleStatesResponse,
  ListRulesData,
  ListRulesResponse,
  ListSharedAccessGrantsData,
  ListSharedAccessGrantsError,
  ListSharedAccessGrantsResponse,
  ListSyncRunsData,
  ListSyncRunsError,
  ListSyncRunsResponse,
  ListSyncsData,
  ListSyncsResponse,
  ListWebhookRunsData,
  ListWebhookRunsError,
  ListWebhookRunsResponse,
  ListWorkflowInterventionsData,
  ListWorkflowInterventionsError,
  ListWorkflowInterventionsResponse,
  ListWorkflowRunsData,
  ListWorkflowRunsError,
  ListWorkflowRunsResponse,
  ListWorkflowsData,
  ListWorkflowsResponse,
  PostAgentThreadMessageData,
  PostAgentThreadMessageError,
  PostAgentThreadMessageResponse,
  QueryObjectLinksData,
  QueryObjectLinksError,
  QueryObjectLinksResponse,
  QueryObjectsData,
  QueryObjectsError,
  QueryObjectsResponse,
  ReactivateAuthMemberData,
  ReactivateAuthMemberError,
  ReactivateAuthMemberResponse,
  ReauthorizeConnectorConnectionData,
  ReauthorizeConnectorConnectionError,
  ReauthorizeConnectorConnectionResponse,
  RecreateAgentThreadSandboxData,
  RecreateAgentThreadSandboxError,
  RecreateAgentThreadSandboxResponse,
  RefreshAuthSessionData,
  RefreshAuthSessionError,
  RefreshAuthSessionResponse,
  RemoveObjectLinkData,
  RemoveObjectLinkError,
  RemoveObjectLinkResponse,
  RequestActionData,
  RequestActionError,
  RequestActionResponse,
  RequestPipelineRunData,
  RequestPipelineRunError,
  RequestPipelineRunResponse,
  RequestSyncRunData,
  RequestSyncRunError,
  RequestSyncRunResponse,
  RequestWorkflowRunData,
  RequestWorkflowRunError,
  RequestWorkflowRunResponse,
  RetryAgentRunData,
  RetryAgentRunError,
  RetryAgentRunResponse,
  RevokeAuthAccessTokenData,
  RevokeAuthAccessTokenError,
  RevokeAuthAccessTokenResponse,
  RevokeAuthInvitationData,
  RevokeAuthInvitationError,
  RevokeAuthInvitationResponse,
  RevokeAuthServiceAccountAccessTokenData,
  RevokeAuthServiceAccountAccessTokenError,
  RevokeAuthServiceAccountAccessTokenResponse,
  RevokeAuthSessionData,
  RevokeAuthSessionError,
  RevokeAuthSessionResponse,
  RevokeConnectorConnectionData,
  RevokeConnectorConnectionError,
  RevokeConnectorConnectionResponse,
  RevokeSharedAccessGrantData,
  RevokeSharedAccessGrantError,
  RevokeSharedAccessGrantResponse,
  SearchObjectsData,
  SearchObjectsError,
  SearchObjectsResponse,
  SelectConnectorConnectionRunAccountData,
  SelectConnectorConnectionRunAccountError,
  SelectConnectorConnectionRunAccountResponse,
  SignFileUploadPartData,
  SignFileUploadPartError,
  SignFileUploadPartResponse,
  SignOutAllData,
  SignOutAllError,
  SignOutAllResponse,
  SignOutData,
  SignOutError,
  SignOutResponse,
  SignOutSharedAccessData,
  SignOutSharedAccessError,
  SignOutSharedAccessResponse,
  StartConnectorConnectionRunData,
  StartConnectorConnectionRunError,
  StartConnectorConnectionRunResponse,
  SubmitWorkflowInterventionData,
  SubmitWorkflowInterventionError,
  SubmitWorkflowInterventionResponse,
  SuspendAuthMemberData,
  SuspendAuthMemberError,
  SuspendAuthMemberResponse,
  UpdateAiLimitPolicyData,
  UpdateAiLimitPolicyError,
  UpdateAiLimitPolicyResponse,
  UpdateAuthMemberGroupsData,
  UpdateAuthMemberGroupsError,
  UpdateAuthMemberGroupsResponse,
  UploadFileContentData,
  UploadFileContentError,
  UploadFileContentResponse,
  UploadFileRawData,
  UploadFileRawError,
  UploadFileRawResponse,
  UpsertObjectData,
  UpsertObjectError,
  UpsertObjectLinkData,
  UpsertObjectLinkError,
  UpsertObjectLinkResponse,
  UpsertObjectResponse,
} from "../types.gen"

/**
 * Start device authorization
 */
export const createDeviceAuthorizationMutation = (
  options?: Partial<Options<CreateDeviceAuthorizationData>>
): UseMutationOptions<
  CreateDeviceAuthorizationResponse,
  CreateDeviceAuthorizationError,
  Options<CreateDeviceAuthorizationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateDeviceAuthorizationResponse,
    CreateDeviceAuthorizationError,
    Options<CreateDeviceAuthorizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDeviceAuthorization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Exchange an approved device authorization
 */
export const exchangeDeviceAuthorizationMutation = (
  options?: Partial<Options<ExchangeDeviceAuthorizationData>>
): UseMutationOptions<
  ExchangeDeviceAuthorizationResponse,
  DefaultError,
  Options<ExchangeDeviceAuthorizationData>
> => {
  const mutationOptions: UseMutationOptions<
    ExchangeDeviceAuthorizationResponse,
    DefaultError,
    Options<ExchangeDeviceAuthorizationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await exchangeDeviceAuthorization({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Refresh a native client's session tokens
 */
export const refreshAuthSessionMutation = (
  options?: Partial<Options<RefreshAuthSessionData>>
): UseMutationOptions<
  RefreshAuthSessionResponse,
  RefreshAuthSessionError,
  Options<RefreshAuthSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    RefreshAuthSessionResponse,
    RefreshAuthSessionError,
    Options<RefreshAuthSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshAuthSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getAuthSessionQueryKey = (options?: Options<GetAuthSessionData>) =>
  createQueryKey("getAuthSession", options)

/**
 * Get current auth session
 */
export const getAuthSessionOptions = (options?: Options<GetAuthSessionData>) =>
  queryOptions<
    GetAuthSessionResponse,
    DefaultError,
    GetAuthSessionResponse,
    ReturnType<typeof getAuthSessionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAuthSessionQueryKey(options),
  })

/**
 * Sign out current auth session
 */
export const signOutMutation = (
  options?: Partial<Options<SignOutData>>
): UseMutationOptions<SignOutResponse, SignOutError, Options<SignOutData>> => {
  const mutationOptions: UseMutationOptions<SignOutResponse, SignOutError, Options<SignOutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await signOut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAuthSessionsQueryKey = (options?: Options<ListAuthSessionsData>) =>
  createQueryKey("listAuthSessions", options)

/**
 * List active sessions for the current user
 */
export const listAuthSessionsOptions = (options?: Options<ListAuthSessionsData>) =>
  queryOptions<
    ListAuthSessionsResponse,
    ListAuthSessionsError,
    ListAuthSessionsResponse,
    ReturnType<typeof listAuthSessionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthSessions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthSessionsQueryKey(options),
  })

/**
 * Revoke one of the current user's sessions
 */
export const revokeAuthSessionMutation = (
  options?: Partial<Options<RevokeAuthSessionData>>
): UseMutationOptions<
  RevokeAuthSessionResponse,
  RevokeAuthSessionError,
  Options<RevokeAuthSessionData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeAuthSessionResponse,
    RevokeAuthSessionError,
    Options<RevokeAuthSessionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeAuthSession({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Sign out the current user everywhere (all devices and apps)
 */
export const signOutAllMutation = (
  options?: Partial<Options<SignOutAllData>>
): UseMutationOptions<SignOutAllResponse, SignOutAllError, Options<SignOutAllData>> => {
  const mutationOptions: UseMutationOptions<
    SignOutAllResponse,
    SignOutAllError,
    Options<SignOutAllData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await signOutAll({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAuthAccessManagementOptionsQueryKey = (
  options?: Options<GetAuthAccessManagementOptionsData>
) => createQueryKey("getAuthAccessManagementOptions", options)

/**
 * Get auth access-token management options
 */
export const getAuthAccessManagementOptionsOptions = (
  options?: Options<GetAuthAccessManagementOptionsData>
) =>
  queryOptions<
    GetAuthAccessManagementOptionsResponse,
    GetAuthAccessManagementOptionsError,
    GetAuthAccessManagementOptionsResponse,
    ReturnType<typeof getAuthAccessManagementOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthAccessManagementOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAuthAccessManagementOptionsQueryKey(options),
  })

export const listAuthAccessTokensQueryKey = (options?: Options<ListAuthAccessTokensData>) =>
  createQueryKey("listAuthAccessTokens", options)

/**
 * List personal access tokens for the current user
 */
export const listAuthAccessTokensOptions = (options?: Options<ListAuthAccessTokensData>) =>
  queryOptions<
    ListAuthAccessTokensResponse,
    ListAuthAccessTokensError,
    ListAuthAccessTokensResponse,
    ReturnType<typeof listAuthAccessTokensQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthAccessTokens({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthAccessTokensQueryKey(options),
  })

/**
 * Create a personal access token
 */
export const createAuthPersonalAccessTokenMutation = (
  options?: Partial<Options<CreateAuthPersonalAccessTokenData>>
): UseMutationOptions<
  CreateAuthPersonalAccessTokenResponse,
  CreateAuthPersonalAccessTokenError,
  Options<CreateAuthPersonalAccessTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAuthPersonalAccessTokenResponse,
    CreateAuthPersonalAccessTokenError,
    Options<CreateAuthPersonalAccessTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAuthPersonalAccessToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Revoke one of the current user's personal access tokens
 */
export const revokeAuthAccessTokenMutation = (
  options?: Partial<Options<RevokeAuthAccessTokenData>>
): UseMutationOptions<
  RevokeAuthAccessTokenResponse,
  RevokeAuthAccessTokenError,
  Options<RevokeAuthAccessTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeAuthAccessTokenResponse,
    RevokeAuthAccessTokenError,
    Options<RevokeAuthAccessTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeAuthAccessToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAuthServiceAccountsQueryKey = (options?: Options<ListAuthServiceAccountsData>) =>
  createQueryKey("listAuthServiceAccounts", options)

/**
 * List auth service accounts
 */
export const listAuthServiceAccountsOptions = (options?: Options<ListAuthServiceAccountsData>) =>
  queryOptions<
    ListAuthServiceAccountsResponse,
    ListAuthServiceAccountsError,
    ListAuthServiceAccountsResponse,
    ReturnType<typeof listAuthServiceAccountsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthServiceAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthServiceAccountsQueryKey(options),
  })

/**
 * Create an auth service account
 */
export const createAuthServiceAccountMutation = (
  options?: Partial<Options<CreateAuthServiceAccountData>>
): UseMutationOptions<
  CreateAuthServiceAccountResponse,
  CreateAuthServiceAccountError,
  Options<CreateAuthServiceAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAuthServiceAccountResponse,
    CreateAuthServiceAccountError,
    Options<CreateAuthServiceAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAuthServiceAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Disable an auth service account
 */
export const disableAuthServiceAccountMutation = (
  options?: Partial<Options<DisableAuthServiceAccountData>>
): UseMutationOptions<
  DisableAuthServiceAccountResponse,
  DisableAuthServiceAccountError,
  Options<DisableAuthServiceAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    DisableAuthServiceAccountResponse,
    DisableAuthServiceAccountError,
    Options<DisableAuthServiceAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await disableAuthServiceAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAuthServiceAccountAccessTokensQueryKey = (
  options: Options<ListAuthServiceAccountAccessTokensData>
) => createQueryKey("listAuthServiceAccountAccessTokens", options)

/**
 * List access tokens for an auth service account
 */
export const listAuthServiceAccountAccessTokensOptions = (
  options: Options<ListAuthServiceAccountAccessTokensData>
) =>
  queryOptions<
    ListAuthServiceAccountAccessTokensResponse,
    ListAuthServiceAccountAccessTokensError,
    ListAuthServiceAccountAccessTokensResponse,
    ReturnType<typeof listAuthServiceAccountAccessTokensQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthServiceAccountAccessTokens({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthServiceAccountAccessTokensQueryKey(options),
  })

/**
 * Create an access token for an auth service account
 */
export const createAuthServiceAccountAccessTokenMutation = (
  options?: Partial<Options<CreateAuthServiceAccountAccessTokenData>>
): UseMutationOptions<
  CreateAuthServiceAccountAccessTokenResponse,
  CreateAuthServiceAccountAccessTokenError,
  Options<CreateAuthServiceAccountAccessTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAuthServiceAccountAccessTokenResponse,
    CreateAuthServiceAccountAccessTokenError,
    Options<CreateAuthServiceAccountAccessTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAuthServiceAccountAccessToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Revoke an access token for an auth service account
 */
export const revokeAuthServiceAccountAccessTokenMutation = (
  options?: Partial<Options<RevokeAuthServiceAccountAccessTokenData>>
): UseMutationOptions<
  RevokeAuthServiceAccountAccessTokenResponse,
  RevokeAuthServiceAccountAccessTokenError,
  Options<RevokeAuthServiceAccountAccessTokenData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeAuthServiceAccountAccessTokenResponse,
    RevokeAuthServiceAccountAccessTokenError,
    Options<RevokeAuthServiceAccountAccessTokenData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeAuthServiceAccountAccessToken({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAuthInvitationsQueryKey = (options?: Options<ListAuthInvitationsData>) =>
  createQueryKey("listAuthInvitations", options)

/**
 * List auth invitations
 */
export const listAuthInvitationsOptions = (options?: Options<ListAuthInvitationsData>) =>
  queryOptions<
    ListAuthInvitationsResponse,
    ListAuthInvitationsError,
    ListAuthInvitationsResponse,
    ReturnType<typeof listAuthInvitationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthInvitations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthInvitationsQueryKey(options),
  })

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const listAuthInvitationsInfiniteQueryKey = (
  options?: Options<ListAuthInvitationsData>
): QueryKey<Options<ListAuthInvitationsData>> =>
  createQueryKey("listAuthInvitations", options, true)

/**
 * List auth invitations
 */
export const listAuthInvitationsInfiniteOptions = (options?: Options<ListAuthInvitationsData>) =>
  infiniteQueryOptions<
    ListAuthInvitationsResponse,
    ListAuthInvitationsError,
    InfiniteData<ListAuthInvitationsResponse>,
    QueryKey<Options<ListAuthInvitationsData>>,
    | string
    | Pick<QueryKey<Options<ListAuthInvitationsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAuthInvitationsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAuthInvitations({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAuthInvitationsInfiniteQueryKey(options),
    }
  )

/**
 * Create an auth invitation
 */
export const createAuthInvitationMutation = (
  options?: Partial<Options<CreateAuthInvitationData>>
): UseMutationOptions<
  CreateAuthInvitationResponse,
  CreateAuthInvitationError,
  Options<CreateAuthInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAuthInvitationResponse,
    CreateAuthInvitationError,
    Options<CreateAuthInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAuthInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAuthInvitationOptionsQueryKey = (options?: Options<GetAuthInvitationOptionsData>) =>
  createQueryKey("getAuthInvitationOptions", options)

/**
 * Get auth invitation options
 */
export const getAuthInvitationOptionsOptions = (options?: Options<GetAuthInvitationOptionsData>) =>
  queryOptions<
    GetAuthInvitationOptionsResponse,
    GetAuthInvitationOptionsError,
    GetAuthInvitationOptionsResponse,
    ReturnType<typeof getAuthInvitationOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthInvitationOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAuthInvitationOptionsQueryKey(options),
  })

/**
 * Revoke an auth invitation
 */
export const revokeAuthInvitationMutation = (
  options?: Partial<Options<RevokeAuthInvitationData>>
): UseMutationOptions<
  RevokeAuthInvitationResponse,
  RevokeAuthInvitationError,
  Options<RevokeAuthInvitationData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeAuthInvitationResponse,
    RevokeAuthInvitationError,
    Options<RevokeAuthInvitationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeAuthInvitation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAuthMembershipOptionsQueryKey = (options?: Options<GetAuthMembershipOptionsData>) =>
  createQueryKey("getAuthMembershipOptions", options)

/**
 * Get auth membership management options
 */
export const getAuthMembershipOptionsOptions = (options?: Options<GetAuthMembershipOptionsData>) =>
  queryOptions<
    GetAuthMembershipOptionsResponse,
    GetAuthMembershipOptionsError,
    GetAuthMembershipOptionsResponse,
    ReturnType<typeof getAuthMembershipOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAuthMembershipOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAuthMembershipOptionsQueryKey(options),
  })

export const listAuthMembersQueryKey = (options?: Options<ListAuthMembersData>) =>
  createQueryKey("listAuthMembers", options)

/**
 * List auth members
 */
export const listAuthMembersOptions = (options?: Options<ListAuthMembersData>) =>
  queryOptions<
    ListAuthMembersResponse,
    ListAuthMembersError,
    ListAuthMembersResponse,
    ReturnType<typeof listAuthMembersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAuthMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAuthMembersQueryKey(options),
  })

export const listAuthMembersInfiniteQueryKey = (
  options?: Options<ListAuthMembersData>
): QueryKey<Options<ListAuthMembersData>> => createQueryKey("listAuthMembers", options, true)

/**
 * List auth members
 */
export const listAuthMembersInfiniteOptions = (options?: Options<ListAuthMembersData>) =>
  infiniteQueryOptions<
    ListAuthMembersResponse,
    ListAuthMembersError,
    InfiniteData<ListAuthMembersResponse>,
    QueryKey<Options<ListAuthMembersData>>,
    string | Pick<QueryKey<Options<ListAuthMembersData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAuthMembersData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAuthMembers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAuthMembersInfiniteQueryKey(options),
    }
  )

/**
 * Update an auth member's groups
 */
export const updateAuthMemberGroupsMutation = (
  options?: Partial<Options<UpdateAuthMemberGroupsData>>
): UseMutationOptions<
  UpdateAuthMemberGroupsResponse,
  UpdateAuthMemberGroupsError,
  Options<UpdateAuthMemberGroupsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAuthMemberGroupsResponse,
    UpdateAuthMemberGroupsError,
    Options<UpdateAuthMemberGroupsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAuthMemberGroups({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Suspend an auth member
 */
export const suspendAuthMemberMutation = (
  options?: Partial<Options<SuspendAuthMemberData>>
): UseMutationOptions<
  SuspendAuthMemberResponse,
  SuspendAuthMemberError,
  Options<SuspendAuthMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    SuspendAuthMemberResponse,
    SuspendAuthMemberError,
    Options<SuspendAuthMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await suspendAuthMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reactivate an auth member
 */
export const reactivateAuthMemberMutation = (
  options?: Partial<Options<ReactivateAuthMemberData>>
): UseMutationOptions<
  ReactivateAuthMemberResponse,
  ReactivateAuthMemberError,
  Options<ReactivateAuthMemberData>
> => {
  const mutationOptions: UseMutationOptions<
    ReactivateAuthMemberResponse,
    ReactivateAuthMemberError,
    Options<ReactivateAuthMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reactivateAuthMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAiAccountingOverviewQueryKey = (options: Options<GetAiAccountingOverviewData>) =>
  createQueryKey("getAiAccountingOverview", options)

/**
 * Get project AI usage and cost analytics
 */
export const getAiAccountingOverviewOptions = (options: Options<GetAiAccountingOverviewData>) =>
  queryOptions<
    GetAiAccountingOverviewResponse,
    GetAiAccountingOverviewError,
    GetAiAccountingOverviewResponse,
    ReturnType<typeof getAiAccountingOverviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAiAccountingOverview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAiAccountingOverviewQueryKey(options),
  })

export const listAiModelCallsQueryKey = (options: Options<ListAiModelCallsData>) =>
  createQueryKey("listAiModelCalls", options)

/**
 * List project AI model-call accounting records
 */
export const listAiModelCallsOptions = (options: Options<ListAiModelCallsData>) =>
  queryOptions<
    ListAiModelCallsResponse,
    ListAiModelCallsError,
    ListAiModelCallsResponse,
    ReturnType<typeof listAiModelCallsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAiModelCalls({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAiModelCallsQueryKey(options),
  })

export const listAiModelCallsInfiniteQueryKey = (
  options: Options<ListAiModelCallsData>
): QueryKey<Options<ListAiModelCallsData>> => createQueryKey("listAiModelCalls", options, true)

/**
 * List project AI model-call accounting records
 */
export const listAiModelCallsInfiniteOptions = (options: Options<ListAiModelCallsData>) =>
  infiniteQueryOptions<
    ListAiModelCallsResponse,
    ListAiModelCallsError,
    InfiniteData<ListAiModelCallsResponse>,
    QueryKey<Options<ListAiModelCallsData>>,
    string | Pick<QueryKey<Options<ListAiModelCallsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAiModelCallsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAiModelCalls({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAiModelCallsInfiniteQueryKey(options),
    }
  )

export const listAiLimitPoliciesQueryKey = (options?: Options<ListAiLimitPoliciesData>) =>
  createQueryKey("listAiLimitPolicies", options)

/**
 * List project AI usage-limit policies
 */
export const listAiLimitPoliciesOptions = (options?: Options<ListAiLimitPoliciesData>) =>
  queryOptions<
    ListAiLimitPoliciesResponse,
    ListAiLimitPoliciesError,
    ListAiLimitPoliciesResponse,
    ReturnType<typeof listAiLimitPoliciesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAiLimitPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAiLimitPoliciesQueryKey(options),
  })

/**
 * Create an AI usage-limit policy
 */
export const createAiLimitPolicyMutation = (
  options?: Partial<Options<CreateAiLimitPolicyData>>
): UseMutationOptions<
  CreateAiLimitPolicyResponse,
  CreateAiLimitPolicyError,
  Options<CreateAiLimitPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAiLimitPolicyResponse,
    CreateAiLimitPolicyError,
    Options<CreateAiLimitPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAiLimitPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAiLimitStatusQueryKey = (options?: Options<GetAiLimitStatusData>) =>
  createQueryKey("getAiLimitStatus", options)

/**
 * Get current project AI usage-limit status
 */
export const getAiLimitStatusOptions = (options?: Options<GetAiLimitStatusData>) =>
  queryOptions<
    GetAiLimitStatusResponse,
    GetAiLimitStatusError,
    GetAiLimitStatusResponse,
    ReturnType<typeof getAiLimitStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAiLimitStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAiLimitStatusQueryKey(options),
  })

export const getAiLimitSubjectOptionsQueryKey = (options?: Options<GetAiLimitSubjectOptionsData>) =>
  createQueryKey("getAiLimitSubjectOptions", options)

/**
 * Get selectable AI usage-limit subjects
 *
 * Lists registered groups and auth principals available for AI usage-limit policies.
 */
export const getAiLimitSubjectOptionsOptions = (options?: Options<GetAiLimitSubjectOptionsData>) =>
  queryOptions<
    GetAiLimitSubjectOptionsResponse,
    GetAiLimitSubjectOptionsError,
    GetAiLimitSubjectOptionsResponse,
    ReturnType<typeof getAiLimitSubjectOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAiLimitSubjectOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAiLimitSubjectOptionsQueryKey(options),
  })

/**
 * Delete an AI usage-limit policy
 */
export const deleteAiLimitPolicyMutation = (
  options?: Partial<Options<DeleteAiLimitPolicyData>>
): UseMutationOptions<
  DeleteAiLimitPolicyResponse,
  DeleteAiLimitPolicyError,
  Options<DeleteAiLimitPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteAiLimitPolicyResponse,
    DeleteAiLimitPolicyError,
    Options<DeleteAiLimitPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAiLimitPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update an AI usage-limit policy
 */
export const updateAiLimitPolicyMutation = (
  options?: Partial<Options<UpdateAiLimitPolicyData>>
): UseMutationOptions<
  UpdateAiLimitPolicyResponse,
  UpdateAiLimitPolicyError,
  Options<UpdateAiLimitPolicyData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAiLimitPolicyResponse,
    UpdateAiLimitPolicyError,
    Options<UpdateAiLimitPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAiLimitPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAiModelCallGroupsQueryKey = (options: Options<ListAiModelCallGroupsData>) =>
  createQueryKey("listAiModelCallGroups", options)

/**
 * List AI model calls grouped by initiating execution
 */
export const listAiModelCallGroupsOptions = (options: Options<ListAiModelCallGroupsData>) =>
  queryOptions<
    ListAiModelCallGroupsResponse,
    ListAiModelCallGroupsError,
    ListAiModelCallGroupsResponse,
    ReturnType<typeof listAiModelCallGroupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAiModelCallGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAiModelCallGroupsQueryKey(options),
  })

export const listAiModelCallGroupsInfiniteQueryKey = (
  options: Options<ListAiModelCallGroupsData>
): QueryKey<Options<ListAiModelCallGroupsData>> =>
  createQueryKey("listAiModelCallGroups", options, true)

/**
 * List AI model calls grouped by initiating execution
 */
export const listAiModelCallGroupsInfiniteOptions = (options: Options<ListAiModelCallGroupsData>) =>
  infiniteQueryOptions<
    ListAiModelCallGroupsResponse,
    ListAiModelCallGroupsError,
    InfiniteData<ListAiModelCallGroupsResponse>,
    QueryKey<Options<ListAiModelCallGroupsData>>,
    | string
    | Pick<QueryKey<Options<ListAiModelCallGroupsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAiModelCallGroupsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAiModelCallGroups({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAiModelCallGroupsInfiniteQueryKey(options),
    }
  )

export const getProjectInfoQueryKey = (options?: Options<GetProjectInfoData>) =>
  createQueryKey("getProjectInfo", options)

/**
 * Get current project metadata
 */
export const getProjectInfoOptions = (options?: Options<GetProjectInfoData>) =>
  queryOptions<
    GetProjectInfoResponse,
    DefaultError,
    GetProjectInfoResponse,
    ReturnType<typeof getProjectInfoQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectInfoQueryKey(options),
  })

export const getStatusQueryKey = (options?: Options<GetStatusData>) =>
  createQueryKey("getStatus", options)

/**
 * Get runtime status
 */
export const getStatusOptions = (options?: Options<GetStatusData>) =>
  queryOptions<
    GetStatusResponse,
    DefaultError,
    GetStatusResponse,
    ReturnType<typeof getStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStatusQueryKey(options),
  })

export const listConnectorsQueryKey = (options?: Options<ListConnectorsData>) =>
  createQueryKey("listConnectors", options)

/**
 * List registered connectors
 */
export const listConnectorsOptions = (options?: Options<ListConnectorsData>) =>
  queryOptions<
    ListConnectorsResponse,
    DefaultError,
    ListConnectorsResponse,
    ReturnType<typeof listConnectorsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listConnectors({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listConnectorsQueryKey(options),
  })

export const getConnectorQueryKey = (options: Options<GetConnectorData>) =>
  createQueryKey("getConnector", options)

/**
 * Get connector metadata
 */
export const getConnectorOptions = (options: Options<GetConnectorData>) =>
  queryOptions<
    GetConnectorResponse,
    GetConnectorError,
    GetConnectorResponse,
    ReturnType<typeof getConnectorQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConnector({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getConnectorQueryKey(options),
  })

export const listConnectorConnectionsQueryKey = (options: Options<ListConnectorConnectionsData>) =>
  createQueryKey("listConnectorConnections", options)

/**
 * List connector connections
 */
export const listConnectorConnectionsOptions = (options: Options<ListConnectorConnectionsData>) =>
  queryOptions<
    ListConnectorConnectionsResponse,
    ListConnectorConnectionsError,
    ListConnectorConnectionsResponse,
    ReturnType<typeof listConnectorConnectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listConnectorConnections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listConnectorConnectionsQueryKey(options),
  })

/**
 * Disconnect a connector account
 */
export const disconnectConnectorConnectionMutation = (
  options?: Partial<Options<DisconnectConnectorConnectionData>>
): UseMutationOptions<
  DisconnectConnectorConnectionResponse,
  DisconnectConnectorConnectionError,
  Options<DisconnectConnectorConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    DisconnectConnectorConnectionResponse,
    DisconnectConnectorConnectionError,
    Options<DisconnectConnectorConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await disconnectConnectorConnection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Revoke a connector authorization
 */
export const revokeConnectorConnectionMutation = (
  options?: Partial<Options<RevokeConnectorConnectionData>>
): UseMutationOptions<
  RevokeConnectorConnectionResponse,
  RevokeConnectorConnectionError,
  Options<RevokeConnectorConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeConnectorConnectionResponse,
    RevokeConnectorConnectionError,
    Options<RevokeConnectorConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeConnectorConnection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listPendingConnectorConnectionRunsQueryKey = (
  options: Options<ListPendingConnectorConnectionRunsData>
) => createQueryKey("listPendingConnectorConnectionRuns", options)

/**
 * List the initiating user's pending connector connection runs
 */
export const listPendingConnectorConnectionRunsOptions = (
  options: Options<ListPendingConnectorConnectionRunsData>
) =>
  queryOptions<
    ListPendingConnectorConnectionRunsResponse,
    ListPendingConnectorConnectionRunsError,
    ListPendingConnectorConnectionRunsResponse,
    ReturnType<typeof listPendingConnectorConnectionRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPendingConnectorConnectionRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listPendingConnectorConnectionRunsQueryKey(options),
  })

/**
 * Start a connector connection run
 */
export const startConnectorConnectionRunMutation = (
  options?: Partial<Options<StartConnectorConnectionRunData>>
): UseMutationOptions<
  StartConnectorConnectionRunResponse,
  StartConnectorConnectionRunError,
  Options<StartConnectorConnectionRunData>
> => {
  const mutationOptions: UseMutationOptions<
    StartConnectorConnectionRunResponse,
    StartConnectorConnectionRunError,
    Options<StartConnectorConnectionRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await startConnectorConnectionRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getConnectorConnectionRunQueryKey = (
  options: Options<GetConnectorConnectionRunData>
) => createQueryKey("getConnectorConnectionRun", options)

/**
 * Get a connector connection run
 */
export const getConnectorConnectionRunOptions = (options: Options<GetConnectorConnectionRunData>) =>
  queryOptions<
    GetConnectorConnectionRunResponse,
    GetConnectorConnectionRunError,
    GetConnectorConnectionRunResponse,
    ReturnType<typeof getConnectorConnectionRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConnectorConnectionRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getConnectorConnectionRunQueryKey(options),
  })

/**
 * Add a connector connection from an existing authorization
 */
export const addConnectorConnectionMutation = (
  options?: Partial<Options<AddConnectorConnectionData>>
): UseMutationOptions<
  AddConnectorConnectionResponse,
  AddConnectorConnectionError,
  Options<AddConnectorConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    AddConnectorConnectionResponse,
    AddConnectorConnectionError,
    Options<AddConnectorConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addConnectorConnection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Select a connector account
 */
export const selectConnectorConnectionRunAccountMutation = (
  options?: Partial<Options<SelectConnectorConnectionRunAccountData>>
): UseMutationOptions<
  SelectConnectorConnectionRunAccountResponse,
  SelectConnectorConnectionRunAccountError,
  Options<SelectConnectorConnectionRunAccountData>
> => {
  const mutationOptions: UseMutationOptions<
    SelectConnectorConnectionRunAccountResponse,
    SelectConnectorConnectionRunAccountError,
    Options<SelectConnectorConnectionRunAccountData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await selectConnectorConnectionRunAccount({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reauthorize a connector connection
 */
export const reauthorizeConnectorConnectionMutation = (
  options?: Partial<Options<ReauthorizeConnectorConnectionData>>
): UseMutationOptions<
  ReauthorizeConnectorConnectionResponse,
  ReauthorizeConnectorConnectionError,
  Options<ReauthorizeConnectorConnectionData>
> => {
  const mutationOptions: UseMutationOptions<
    ReauthorizeConnectorConnectionResponse,
    ReauthorizeConnectorConnectionError,
    Options<ReauthorizeConnectorConnectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reauthorizeConnectorConnection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listDatasetsQueryKey = (options?: Options<ListDatasetsData>) =>
  createQueryKey("listDatasets", options)

/**
 * List registered datasets
 */
export const listDatasetsOptions = (options?: Options<ListDatasetsData>) =>
  queryOptions<
    ListDatasetsResponse,
    ListDatasetsError,
    ListDatasetsResponse,
    ReturnType<typeof listDatasetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDatasets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listDatasetsQueryKey(options),
  })

export const getDatasetQueryKey = (options: Options<GetDatasetData>) =>
  createQueryKey("getDataset", options)

/**
 * Get dataset metadata
 */
export const getDatasetOptions = (options: Options<GetDatasetData>) =>
  queryOptions<
    GetDatasetResponse,
    GetDatasetError,
    GetDatasetResponse,
    ReturnType<typeof getDatasetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDataset({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDatasetQueryKey(options),
  })

export const listDatasetVersionsQueryKey = (options: Options<ListDatasetVersionsData>) =>
  createQueryKey("listDatasetVersions", options)

/**
 * List dataset versions
 */
export const listDatasetVersionsOptions = (options: Options<ListDatasetVersionsData>) =>
  queryOptions<
    ListDatasetVersionsResponse,
    ListDatasetVersionsError,
    ListDatasetVersionsResponse,
    ReturnType<typeof listDatasetVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDatasetVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listDatasetVersionsQueryKey(options),
  })

export const getDatasetVersionQueryKey = (options: Options<GetDatasetVersionData>) =>
  createQueryKey("getDatasetVersion", options)

/**
 * Get dataset version
 */
export const getDatasetVersionOptions = (options: Options<GetDatasetVersionData>) =>
  queryOptions<
    GetDatasetVersionResponse,
    GetDatasetVersionError,
    GetDatasetVersionResponse,
    ReturnType<typeof getDatasetVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDatasetVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDatasetVersionQueryKey(options),
  })

export const listDatasetRowsQueryKey = (options: Options<ListDatasetRowsData>) =>
  createQueryKey("listDatasetRows", options)

/**
 * Preview dataset rows
 */
export const listDatasetRowsOptions = (options: Options<ListDatasetRowsData>) =>
  queryOptions<
    ListDatasetRowsResponse,
    ListDatasetRowsError,
    ListDatasetRowsResponse,
    ReturnType<typeof listDatasetRowsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDatasetRows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listDatasetRowsQueryKey(options),
  })

export const listDatasetRowsInfiniteQueryKey = (
  options: Options<ListDatasetRowsData>
): QueryKey<Options<ListDatasetRowsData>> => createQueryKey("listDatasetRows", options, true)

/**
 * Preview dataset rows
 */
export const listDatasetRowsInfiniteOptions = (options: Options<ListDatasetRowsData>) =>
  infiniteQueryOptions<
    ListDatasetRowsResponse,
    ListDatasetRowsError,
    InfiniteData<ListDatasetRowsResponse>,
    QueryKey<Options<ListDatasetRowsData>>,
    string | Pick<QueryKey<Options<ListDatasetRowsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListDatasetRowsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listDatasetRows({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listDatasetRowsInfiniteQueryKey(options),
    }
  )

export const listSyncsQueryKey = (options?: Options<ListSyncsData>) =>
  createQueryKey("listSyncs", options)

/**
 * List registered syncs
 */
export const listSyncsOptions = (options?: Options<ListSyncsData>) =>
  queryOptions<
    ListSyncsResponse,
    DefaultError,
    ListSyncsResponse,
    ReturnType<typeof listSyncsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSyncs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSyncsQueryKey(options),
  })

export const getSyncQueryKey = (options: Options<GetSyncData>) => createQueryKey("getSync", options)

/**
 * Get sync metadata
 */
export const getSyncOptions = (options: Options<GetSyncData>) =>
  queryOptions<GetSyncResponse, GetSyncError, GetSyncResponse, ReturnType<typeof getSyncQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSync({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSyncQueryKey(options),
  })

export const listSyncRunsQueryKey = (options?: Options<ListSyncRunsData>) =>
  createQueryKey("listSyncRuns", options)

/**
 * List sync run history
 */
export const listSyncRunsOptions = (options?: Options<ListSyncRunsData>) =>
  queryOptions<
    ListSyncRunsResponse,
    ListSyncRunsError,
    ListSyncRunsResponse,
    ReturnType<typeof listSyncRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSyncRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSyncRunsQueryKey(options),
  })

export const listSyncRunsInfiniteQueryKey = (
  options?: Options<ListSyncRunsData>
): QueryKey<Options<ListSyncRunsData>> => createQueryKey("listSyncRuns", options, true)

/**
 * List sync run history
 */
export const listSyncRunsInfiniteOptions = (options?: Options<ListSyncRunsData>) =>
  infiniteQueryOptions<
    ListSyncRunsResponse,
    ListSyncRunsError,
    InfiniteData<ListSyncRunsResponse>,
    QueryKey<Options<ListSyncRunsData>>,
    string | Pick<QueryKey<Options<ListSyncRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListSyncRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listSyncRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listSyncRunsInfiniteQueryKey(options),
    }
  )

/**
 * Request a sync run
 */
export const requestSyncRunMutation = (
  options?: Partial<Options<RequestSyncRunData>>
): UseMutationOptions<RequestSyncRunResponse, RequestSyncRunError, Options<RequestSyncRunData>> => {
  const mutationOptions: UseMutationOptions<
    RequestSyncRunResponse,
    RequestSyncRunError,
    Options<RequestSyncRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestSyncRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listPipelinesQueryKey = (options?: Options<ListPipelinesData>) =>
  createQueryKey("listPipelines", options)

/**
 * List registered pipelines
 */
export const listPipelinesOptions = (options?: Options<ListPipelinesData>) =>
  queryOptions<
    ListPipelinesResponse,
    DefaultError,
    ListPipelinesResponse,
    ReturnType<typeof listPipelinesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPipelines({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listPipelinesQueryKey(options),
  })

export const getPipelineQueryKey = (options: Options<GetPipelineData>) =>
  createQueryKey("getPipeline", options)

/**
 * Get pipeline metadata
 */
export const getPipelineOptions = (options: Options<GetPipelineData>) =>
  queryOptions<
    GetPipelineResponse,
    GetPipelineError,
    GetPipelineResponse,
    ReturnType<typeof getPipelineQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPipeline({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPipelineQueryKey(options),
  })

export const listPipelineRunsQueryKey = (options?: Options<ListPipelineRunsData>) =>
  createQueryKey("listPipelineRuns", options)

/**
 * List pipeline run history
 */
export const listPipelineRunsOptions = (options?: Options<ListPipelineRunsData>) =>
  queryOptions<
    ListPipelineRunsResponse,
    ListPipelineRunsError,
    ListPipelineRunsResponse,
    ReturnType<typeof listPipelineRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPipelineRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listPipelineRunsQueryKey(options),
  })

export const listPipelineRunsInfiniteQueryKey = (
  options?: Options<ListPipelineRunsData>
): QueryKey<Options<ListPipelineRunsData>> => createQueryKey("listPipelineRuns", options, true)

/**
 * List pipeline run history
 */
export const listPipelineRunsInfiniteOptions = (options?: Options<ListPipelineRunsData>) =>
  infiniteQueryOptions<
    ListPipelineRunsResponse,
    ListPipelineRunsError,
    InfiniteData<ListPipelineRunsResponse>,
    QueryKey<Options<ListPipelineRunsData>>,
    string | Pick<QueryKey<Options<ListPipelineRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListPipelineRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listPipelineRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listPipelineRunsInfiniteQueryKey(options),
    }
  )

export const getPipelineRunQueryKey = (options: Options<GetPipelineRunData>) =>
  createQueryKey("getPipelineRun", options)

/**
 * Get pipeline run detail
 */
export const getPipelineRunOptions = (options: Options<GetPipelineRunData>) =>
  queryOptions<
    GetPipelineRunResponse,
    GetPipelineRunError,
    GetPipelineRunResponse,
    ReturnType<typeof getPipelineRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPipelineRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPipelineRunQueryKey(options),
  })

/**
 * Request a pipeline run
 */
export const requestPipelineRunMutation = (
  options?: Partial<Options<RequestPipelineRunData>>
): UseMutationOptions<
  RequestPipelineRunResponse,
  RequestPipelineRunError,
  Options<RequestPipelineRunData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestPipelineRunResponse,
    RequestPipelineRunError,
    Options<RequestPipelineRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestPipelineRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listWorkflowsQueryKey = (options?: Options<ListWorkflowsData>) =>
  createQueryKey("listWorkflows", options)

/**
 * List registered workflows
 */
export const listWorkflowsOptions = (options?: Options<ListWorkflowsData>) =>
  queryOptions<
    ListWorkflowsResponse,
    DefaultError,
    ListWorkflowsResponse,
    ReturnType<typeof listWorkflowsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflows({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listWorkflowsQueryKey(options),
  })

export const getWorkflowQueryKey = (options: Options<GetWorkflowData>) =>
  createQueryKey("getWorkflow", options)

/**
 * Get workflow metadata
 */
export const getWorkflowOptions = (options: Options<GetWorkflowData>) =>
  queryOptions<
    GetWorkflowResponse,
    GetWorkflowError,
    GetWorkflowResponse,
    ReturnType<typeof getWorkflowQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflow({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowQueryKey(options),
  })

export const listWorkflowInterventionsQueryKey = (
  options?: Options<ListWorkflowInterventionsData>
) => createQueryKey("listWorkflowInterventions", options)

/**
 * List workflow interventions
 */
export const listWorkflowInterventionsOptions = (
  options?: Options<ListWorkflowInterventionsData>
) =>
  queryOptions<
    ListWorkflowInterventionsResponse,
    ListWorkflowInterventionsError,
    ListWorkflowInterventionsResponse,
    ReturnType<typeof listWorkflowInterventionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflowInterventions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listWorkflowInterventionsQueryKey(options),
  })

export const listWorkflowInterventionsInfiniteQueryKey = (
  options?: Options<ListWorkflowInterventionsData>
): QueryKey<Options<ListWorkflowInterventionsData>> =>
  createQueryKey("listWorkflowInterventions", options, true)

/**
 * List workflow interventions
 */
export const listWorkflowInterventionsInfiniteOptions = (
  options?: Options<ListWorkflowInterventionsData>
) =>
  infiniteQueryOptions<
    ListWorkflowInterventionsResponse,
    ListWorkflowInterventionsError,
    InfiniteData<ListWorkflowInterventionsResponse>,
    QueryKey<Options<ListWorkflowInterventionsData>>,
    | string
    | Pick<
        QueryKey<Options<ListWorkflowInterventionsData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWorkflowInterventionsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listWorkflowInterventions({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listWorkflowInterventionsInfiniteQueryKey(options),
    }
  )

export const getWorkflowInterventionQueryKey = (options: Options<GetWorkflowInterventionData>) =>
  createQueryKey("getWorkflowIntervention", options)

/**
 * Get workflow intervention detail
 */
export const getWorkflowInterventionOptions = (options: Options<GetWorkflowInterventionData>) =>
  queryOptions<
    GetWorkflowInterventionResponse,
    GetWorkflowInterventionError,
    GetWorkflowInterventionResponse,
    ReturnType<typeof getWorkflowInterventionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowIntervention({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowInterventionQueryKey(options),
  })

/**
 * Submit a workflow intervention response
 */
export const submitWorkflowInterventionMutation = (
  options?: Partial<Options<SubmitWorkflowInterventionData>>
): UseMutationOptions<
  SubmitWorkflowInterventionResponse,
  SubmitWorkflowInterventionError,
  Options<SubmitWorkflowInterventionData>
> => {
  const mutationOptions: UseMutationOptions<
    SubmitWorkflowInterventionResponse,
    SubmitWorkflowInterventionError,
    Options<SubmitWorkflowInterventionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitWorkflowIntervention({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Cancel a workflow intervention
 */
export const cancelWorkflowInterventionMutation = (
  options?: Partial<Options<CancelWorkflowInterventionData>>
): UseMutationOptions<
  CancelWorkflowInterventionResponse,
  CancelWorkflowInterventionError,
  Options<CancelWorkflowInterventionData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelWorkflowInterventionResponse,
    CancelWorkflowInterventionError,
    Options<CancelWorkflowInterventionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelWorkflowIntervention({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listWorkflowRunsQueryKey = (options?: Options<ListWorkflowRunsData>) =>
  createQueryKey("listWorkflowRuns", options)

/**
 * List workflow run history
 */
export const listWorkflowRunsOptions = (options?: Options<ListWorkflowRunsData>) =>
  queryOptions<
    ListWorkflowRunsResponse,
    ListWorkflowRunsError,
    ListWorkflowRunsResponse,
    ReturnType<typeof listWorkflowRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWorkflowRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listWorkflowRunsQueryKey(options),
  })

export const listWorkflowRunsInfiniteQueryKey = (
  options?: Options<ListWorkflowRunsData>
): QueryKey<Options<ListWorkflowRunsData>> => createQueryKey("listWorkflowRuns", options, true)

/**
 * List workflow run history
 */
export const listWorkflowRunsInfiniteOptions = (options?: Options<ListWorkflowRunsData>) =>
  infiniteQueryOptions<
    ListWorkflowRunsResponse,
    ListWorkflowRunsError,
    InfiniteData<ListWorkflowRunsResponse>,
    QueryKey<Options<ListWorkflowRunsData>>,
    string | Pick<QueryKey<Options<ListWorkflowRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWorkflowRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listWorkflowRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listWorkflowRunsInfiniteQueryKey(options),
    }
  )

export const getWorkflowRunQueryKey = (options: Options<GetWorkflowRunData>) =>
  createQueryKey("getWorkflowRun", options)

/**
 * Get workflow run detail
 */
export const getWorkflowRunOptions = (options: Options<GetWorkflowRunData>) =>
  queryOptions<
    GetWorkflowRunResponse,
    GetWorkflowRunError,
    GetWorkflowRunResponse,
    ReturnType<typeof getWorkflowRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowRunQueryKey(options),
  })

export const getWorkflowAgentNodeExecutionQueryKey = (
  options: Options<GetWorkflowAgentNodeExecutionData>
) => createQueryKey("getWorkflowAgentNodeExecution", options)

/**
 * Get workflow agent node execution detail
 */
export const getWorkflowAgentNodeExecutionOptions = (
  options: Options<GetWorkflowAgentNodeExecutionData>
) =>
  queryOptions<
    GetWorkflowAgentNodeExecutionResponse,
    GetWorkflowAgentNodeExecutionError,
    GetWorkflowAgentNodeExecutionResponse,
    ReturnType<typeof getWorkflowAgentNodeExecutionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowAgentNodeExecution({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowAgentNodeExecutionQueryKey(options),
  })

/**
 * Cancel a workflow run
 */
export const cancelWorkflowRunMutation = (
  options?: Partial<Options<CancelWorkflowRunData>>
): UseMutationOptions<
  CancelWorkflowRunResponse,
  CancelWorkflowRunError,
  Options<CancelWorkflowRunData>
> => {
  const mutationOptions: UseMutationOptions<
    CancelWorkflowRunResponse,
    CancelWorkflowRunError,
    Options<CancelWorkflowRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelWorkflowRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getWorkflowRunFileContentQueryKey = (
  options: Options<GetWorkflowRunFileContentData>
) => createQueryKey("getWorkflowRunFileContent", options)

/**
 * Get workflow run file content
 */
export const getWorkflowRunFileContentOptions = (options: Options<GetWorkflowRunFileContentData>) =>
  queryOptions<
    GetWorkflowRunFileContentResponse,
    GetWorkflowRunFileContentError,
    GetWorkflowRunFileContentResponse,
    ReturnType<typeof getWorkflowRunFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowRunFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowRunFileContentQueryKey(options),
  })

export const getWorkflowNodeRunFileContentQueryKey = (
  options: Options<GetWorkflowNodeRunFileContentData>
) => createQueryKey("getWorkflowNodeRunFileContent", options)

/**
 * Get workflow node run file content
 */
export const getWorkflowNodeRunFileContentOptions = (
  options: Options<GetWorkflowNodeRunFileContentData>
) =>
  queryOptions<
    GetWorkflowNodeRunFileContentResponse,
    GetWorkflowNodeRunFileContentError,
    GetWorkflowNodeRunFileContentResponse,
    ReturnType<typeof getWorkflowNodeRunFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWorkflowNodeRunFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getWorkflowNodeRunFileContentQueryKey(options),
  })

/**
 * Request a workflow run
 */
export const requestWorkflowRunMutation = (
  options?: Partial<Options<RequestWorkflowRunData>>
): UseMutationOptions<
  RequestWorkflowRunResponse,
  RequestWorkflowRunError,
  Options<RequestWorkflowRunData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestWorkflowRunResponse,
    RequestWorkflowRunError,
    Options<RequestWorkflowRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestWorkflowRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listRulesQueryKey = (options?: Options<ListRulesData>) =>
  createQueryKey("listRules", options)

/**
 * List registered rules
 */
export const listRulesOptions = (options?: Options<ListRulesData>) =>
  queryOptions<
    ListRulesResponse,
    DefaultError,
    ListRulesResponse,
    ReturnType<typeof listRulesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRulesQueryKey(options),
  })

export const getRuleQueryKey = (options: Options<GetRuleData>) => createQueryKey("getRule", options)

/**
 * Get rule metadata
 */
export const getRuleOptions = (options: Options<GetRuleData>) =>
  queryOptions<GetRuleResponse, GetRuleError, GetRuleResponse, ReturnType<typeof getRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRuleQueryKey(options),
  })

export const listRuleStatesQueryKey = (options?: Options<ListRuleStatesData>) =>
  createQueryKey("listRuleStates", options)

/**
 * List active rule states
 */
export const listRuleStatesOptions = (options?: Options<ListRuleStatesData>) =>
  queryOptions<
    ListRuleStatesResponse,
    ListRuleStatesError,
    ListRuleStatesResponse,
    ReturnType<typeof listRuleStatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRuleStates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRuleStatesQueryKey(options),
  })

export const listRuleStatesInfiniteQueryKey = (
  options?: Options<ListRuleStatesData>
): QueryKey<Options<ListRuleStatesData>> => createQueryKey("listRuleStates", options, true)

/**
 * List active rule states
 */
export const listRuleStatesInfiniteOptions = (options?: Options<ListRuleStatesData>) =>
  infiniteQueryOptions<
    ListRuleStatesResponse,
    ListRuleStatesError,
    InfiniteData<ListRuleStatesResponse>,
    QueryKey<Options<ListRuleStatesData>>,
    string | Pick<QueryKey<Options<ListRuleStatesData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListRuleStatesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listRuleStates({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listRuleStatesInfiniteQueryKey(options),
    }
  )

export const listSharedAccessGrantsQueryKey = (options: Options<ListSharedAccessGrantsData>) =>
  createQueryKey("listSharedAccessGrants", options)

/**
 * List shared-access grants
 */
export const listSharedAccessGrantsOptions = (options: Options<ListSharedAccessGrantsData>) =>
  queryOptions<
    ListSharedAccessGrantsResponse,
    ListSharedAccessGrantsError,
    ListSharedAccessGrantsResponse,
    ReturnType<typeof listSharedAccessGrantsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSharedAccessGrants({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSharedAccessGrantsQueryKey(options),
  })

export const listSharedAccessGrantsInfiniteQueryKey = (
  options: Options<ListSharedAccessGrantsData>
): QueryKey<Options<ListSharedAccessGrantsData>> =>
  createQueryKey("listSharedAccessGrants", options, true)

/**
 * List shared-access grants
 */
export const listSharedAccessGrantsInfiniteOptions = (
  options: Options<ListSharedAccessGrantsData>
) =>
  infiniteQueryOptions<
    ListSharedAccessGrantsResponse,
    ListSharedAccessGrantsError,
    InfiniteData<ListSharedAccessGrantsResponse>,
    QueryKey<Options<ListSharedAccessGrantsData>>,
    | number
    | Pick<QueryKey<Options<ListSharedAccessGrantsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListSharedAccessGrantsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listSharedAccessGrants({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listSharedAccessGrantsInfiniteQueryKey(options),
    }
  )

/**
 * Issue a shared-access grant
 */
export const issueSharedAccessGrantMutation = (
  options?: Partial<Options<IssueSharedAccessGrantData>>
): UseMutationOptions<
  IssueSharedAccessGrantResponse,
  IssueSharedAccessGrantError,
  Options<IssueSharedAccessGrantData>
> => {
  const mutationOptions: UseMutationOptions<
    IssueSharedAccessGrantResponse,
    IssueSharedAccessGrantError,
    Options<IssueSharedAccessGrantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await issueSharedAccessGrant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Revoke a shared-access grant
 */
export const revokeSharedAccessGrantMutation = (
  options?: Partial<Options<RevokeSharedAccessGrantData>>
): UseMutationOptions<
  RevokeSharedAccessGrantResponse,
  RevokeSharedAccessGrantError,
  Options<RevokeSharedAccessGrantData>
> => {
  const mutationOptions: UseMutationOptions<
    RevokeSharedAccessGrantResponse,
    RevokeSharedAccessGrantError,
    Options<RevokeSharedAccessGrantData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await revokeSharedAccessGrant({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Exchange a shared link for a short-lived session
 */
export const exchangeSharedAccessMutation = (
  options?: Partial<Options<ExchangeSharedAccessData>>
): UseMutationOptions<
  ExchangeSharedAccessResponse,
  ExchangeSharedAccessError,
  Options<ExchangeSharedAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    ExchangeSharedAccessResponse,
    ExchangeSharedAccessError,
    Options<ExchangeSharedAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await exchangeSharedAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSharedAccessSessionQueryKey = (options: Options<GetSharedAccessSessionData>) =>
  createQueryKey("getSharedAccessSession", options)

/**
 * Get the current shared-access session
 */
export const getSharedAccessSessionOptions = (options: Options<GetSharedAccessSessionData>) =>
  queryOptions<
    GetSharedAccessSessionResponse,
    GetSharedAccessSessionError,
    GetSharedAccessSessionResponse,
    ReturnType<typeof getSharedAccessSessionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSharedAccessSession({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSharedAccessSessionQueryKey(options),
  })

/**
 * Sign out a shared-access session
 */
export const signOutSharedAccessMutation = (
  options?: Partial<Options<SignOutSharedAccessData>>
): UseMutationOptions<
  SignOutSharedAccessResponse,
  SignOutSharedAccessError,
  Options<SignOutSharedAccessData>
> => {
  const mutationOptions: UseMutationOptions<
    SignOutSharedAccessResponse,
    SignOutSharedAccessError,
    Options<SignOutSharedAccessData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await signOutSharedAccess({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listObjectTypesQueryKey = (options?: Options<ListObjectTypesData>) =>
  createQueryKey("listObjectTypes", options)

/**
 * List registered object types
 */
export const listObjectTypesOptions = (options?: Options<ListObjectTypesData>) =>
  queryOptions<
    ListObjectTypesResponse,
    DefaultError,
    ListObjectTypesResponse,
    ReturnType<typeof listObjectTypesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listObjectTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listObjectTypesQueryKey(options),
  })

export const getObjectTypeQueryKey = (options: Options<GetObjectTypeData>) =>
  createQueryKey("getObjectType", options)

/**
 * Get object type definition
 */
export const getObjectTypeOptions = (options: Options<GetObjectTypeData>) =>
  queryOptions<
    GetObjectTypeResponse,
    GetObjectTypeError,
    GetObjectTypeResponse,
    ReturnType<typeof getObjectTypeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getObjectType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getObjectTypeQueryKey(options),
  })

export const searchObjectsQueryKey = (options: Options<SearchObjectsData>) =>
  createQueryKey("searchObjects", options)

/**
 * Search objects
 */
export const searchObjectsOptions = (options: Options<SearchObjectsData>) =>
  queryOptions<
    SearchObjectsResponse,
    SearchObjectsError,
    SearchObjectsResponse,
    ReturnType<typeof searchObjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchObjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: searchObjectsQueryKey(options),
  })

export const listObjectsQueryKey = (options?: Options<ListObjectsData>) =>
  createQueryKey("listObjects", options)

/**
 * List objects
 */
export const listObjectsOptions = (options?: Options<ListObjectsData>) =>
  queryOptions<
    ListObjectsResponse,
    ListObjectsError,
    ListObjectsResponse,
    ReturnType<typeof listObjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listObjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listObjectsQueryKey(options),
  })

export const listObjectsInfiniteQueryKey = (
  options?: Options<ListObjectsData>
): QueryKey<Options<ListObjectsData>> => createQueryKey("listObjects", options, true)

/**
 * List objects
 */
export const listObjectsInfiniteOptions = (options?: Options<ListObjectsData>) =>
  infiniteQueryOptions<
    ListObjectsResponse,
    ListObjectsError,
    InfiniteData<ListObjectsResponse>,
    QueryKey<Options<ListObjectsData>>,
    string | Pick<QueryKey<Options<ListObjectsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListObjectsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listObjects({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listObjectsInfiniteQueryKey(options),
    }
  )

/**
 * Query objects
 */
export const queryObjectsMutation = (
  options?: Partial<Options<QueryObjectsData>>
): UseMutationOptions<QueryObjectsResponse, QueryObjectsError, Options<QueryObjectsData>> => {
  const mutationOptions: UseMutationOptions<
    QueryObjectsResponse,
    QueryObjectsError,
    Options<QueryObjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await queryObjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Query object links
 */
export const queryObjectLinksMutation = (
  options?: Partial<Options<QueryObjectLinksData>>
): UseMutationOptions<
  QueryObjectLinksResponse,
  QueryObjectLinksError,
  Options<QueryObjectLinksData>
> => {
  const mutationOptions: UseMutationOptions<
    QueryObjectLinksResponse,
    QueryObjectLinksError,
    Options<QueryObjectLinksData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await queryObjectLinks({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Count objects
 */
export const countObjectsMutation = (
  options?: Partial<Options<CountObjectsData>>
): UseMutationOptions<CountObjectsResponse, CountObjectsError, Options<CountObjectsData>> => {
  const mutationOptions: UseMutationOptions<
    CountObjectsResponse,
    CountObjectsError,
    Options<CountObjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await countObjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Check object existence
 */
export const existsObjectsMutation = (
  options?: Partial<Options<ExistsObjectsData>>
): UseMutationOptions<ExistsObjectsResponse, ExistsObjectsError, Options<ExistsObjectsData>> => {
  const mutationOptions: UseMutationOptions<
    ExistsObjectsResponse,
    ExistsObjectsError,
    Options<ExistsObjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await existsObjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Facet objects
 */
export const facetObjectsMutation = (
  options?: Partial<Options<FacetObjectsData>>
): UseMutationOptions<FacetObjectsResponse, FacetObjectsError, Options<FacetObjectsData>> => {
  const mutationOptions: UseMutationOptions<
    FacetObjectsResponse,
    FacetObjectsError,
    Options<FacetObjectsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await facetObjects({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getObjectFileContentQueryKey = (options: Options<GetObjectFileContentData>) =>
  createQueryKey("getObjectFileContent", options)

/**
 * Get object file content
 */
export const getObjectFileContentOptions = (options: Options<GetObjectFileContentData>) =>
  queryOptions<
    GetObjectFileContentResponse,
    GetObjectFileContentError,
    GetObjectFileContentResponse,
    ReturnType<typeof getObjectFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getObjectFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getObjectFileContentQueryKey(options),
  })

export const getObjectQueryKey = (options: Options<GetObjectData>) =>
  createQueryKey("getObject", options)

/**
 * Get object by id
 */
export const getObjectOptions = (options: Options<GetObjectData>) =>
  queryOptions<
    GetObjectResponse,
    GetObjectError,
    GetObjectResponse,
    ReturnType<typeof getObjectQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getObject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getObjectQueryKey(options),
  })

/**
 * Create or update object
 */
export const upsertObjectMutation = (
  options?: Partial<Options<UpsertObjectData>>
): UseMutationOptions<UpsertObjectResponse, UpsertObjectError, Options<UpsertObjectData>> => {
  const mutationOptions: UseMutationOptions<
    UpsertObjectResponse,
    UpsertObjectError,
    Options<UpsertObjectData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertObject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listActionsQueryKey = (options?: Options<ListActionsData>) =>
  createQueryKey("listActions", options)

/**
 * List registered actions
 */
export const listActionsOptions = (options?: Options<ListActionsData>) =>
  queryOptions<
    ListActionsResponse,
    DefaultError,
    ListActionsResponse,
    ReturnType<typeof listActionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listActions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listActionsQueryKey(options),
  })

export const getActionQueryKey = (options: Options<GetActionData>) =>
  createQueryKey("getAction", options)

/**
 * Get action metadata
 */
export const getActionOptions = (options: Options<GetActionData>) =>
  queryOptions<
    GetActionResponse,
    GetActionError,
    GetActionResponse,
    ReturnType<typeof getActionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getActionQueryKey(options),
  })

/**
 * Request an action
 */
export const requestActionMutation = (
  options?: Partial<Options<RequestActionData>>
): UseMutationOptions<RequestActionResponse, RequestActionError, Options<RequestActionData>> => {
  const mutationOptions: UseMutationOptions<
    RequestActionResponse,
    RequestActionError,
    Options<RequestActionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await requestAction({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Upload a file
 */
export const uploadFileRawMutation = (
  options?: Partial<Options<UploadFileRawData>>
): UseMutationOptions<UploadFileRawResponse, UploadFileRawError, Options<UploadFileRawData>> => {
  const mutationOptions: UseMutationOptions<
    UploadFileRawResponse,
    UploadFileRawError,
    Options<UploadFileRawData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadFileRaw({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Create a staged file upload
 */
export const createFileUploadMutation = (
  options?: Partial<Options<CreateFileUploadData>>
): UseMutationOptions<
  CreateFileUploadResponse,
  CreateFileUploadError,
  Options<CreateFileUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateFileUploadResponse,
    CreateFileUploadError,
    Options<CreateFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Upload staged file content through Sixb
 */
export const uploadFileContentMutation = (
  options?: Partial<Options<UploadFileContentData>>
): UseMutationOptions<
  UploadFileContentResponse,
  UploadFileContentError,
  Options<UploadFileContentData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadFileContentResponse,
    UploadFileContentError,
    Options<UploadFileContentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadFileContent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Sign a staged multipart upload part
 */
export const signFileUploadPartMutation = (
  options?: Partial<Options<SignFileUploadPartData>>
): UseMutationOptions<
  SignFileUploadPartResponse,
  SignFileUploadPartError,
  Options<SignFileUploadPartData>
> => {
  const mutationOptions: UseMutationOptions<
    SignFileUploadPartResponse,
    SignFileUploadPartError,
    Options<SignFileUploadPartData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await signFileUploadPart({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Complete a staged file upload
 */
export const completeFileUploadMutation = (
  options?: Partial<Options<CompleteFileUploadData>>
): UseMutationOptions<
  CompleteFileUploadResponse,
  CompleteFileUploadError,
  Options<CompleteFileUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    CompleteFileUploadResponse,
    CompleteFileUploadError,
    Options<CompleteFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await completeFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Abort a staged file upload
 */
export const abortFileUploadMutation = (
  options?: Partial<Options<AbortFileUploadData>>
): UseMutationOptions<
  AbortFileUploadResponse,
  AbortFileUploadError,
  Options<AbortFileUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    AbortFileUploadResponse,
    AbortFileUploadError,
    Options<AbortFileUploadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await abortFileUpload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listActionRunsQueryKey = (options?: Options<ListActionRunsData>) =>
  createQueryKey("listActionRuns", options)

/**
 * List action run history
 */
export const listActionRunsOptions = (options?: Options<ListActionRunsData>) =>
  queryOptions<
    ListActionRunsResponse,
    ListActionRunsError,
    ListActionRunsResponse,
    ReturnType<typeof listActionRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listActionRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listActionRunsQueryKey(options),
  })

export const listActionRunsInfiniteQueryKey = (
  options?: Options<ListActionRunsData>
): QueryKey<Options<ListActionRunsData>> => createQueryKey("listActionRuns", options, true)

/**
 * List action run history
 */
export const listActionRunsInfiniteOptions = (options?: Options<ListActionRunsData>) =>
  infiniteQueryOptions<
    ListActionRunsResponse,
    ListActionRunsError,
    InfiniteData<ListActionRunsResponse>,
    QueryKey<Options<ListActionRunsData>>,
    string | Pick<QueryKey<Options<ListActionRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListActionRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listActionRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listActionRunsInfiniteQueryKey(options),
    }
  )

export const getActionRunQueryKey = (options: Options<GetActionRunData>) =>
  createQueryKey("getActionRun", options)

/**
 * Get action run detail
 */
export const getActionRunOptions = (options: Options<GetActionRunData>) =>
  queryOptions<
    GetActionRunResponse,
    GetActionRunError,
    GetActionRunResponse,
    ReturnType<typeof getActionRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActionRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getActionRunQueryKey(options),
  })

export const getActionRunFileContentQueryKey = (options: Options<GetActionRunFileContentData>) =>
  createQueryKey("getActionRunFileContent", options)

/**
 * Get action run file content
 */
export const getActionRunFileContentOptions = (options: Options<GetActionRunFileContentData>) =>
  queryOptions<
    GetActionRunFileContentResponse,
    GetActionRunFileContentError,
    GetActionRunFileContentResponse,
    ReturnType<typeof getActionRunFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getActionRunFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getActionRunFileContentQueryKey(options),
  })

export const getAgentQueryKey = (options?: Options<GetAgentData>) =>
  createQueryKey("getAgent", options)

/**
 * Get the project Agent
 */
export const getAgentOptions = (options?: Options<GetAgentData>) =>
  queryOptions<
    GetAgentResponse,
    GetAgentError,
    GetAgentResponse,
    ReturnType<typeof getAgentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAgent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAgentQueryKey(options),
  })

export const listAgentThreadsQueryKey = (options?: Options<ListAgentThreadsData>) =>
  createQueryKey("listAgentThreads", options)

/**
 * List agent threads
 */
export const listAgentThreadsOptions = (options?: Options<ListAgentThreadsData>) =>
  queryOptions<
    ListAgentThreadsResponse,
    ListAgentThreadsError,
    ListAgentThreadsResponse,
    ReturnType<typeof listAgentThreadsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAgentThreads({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAgentThreadsQueryKey(options),
  })

export const listAgentThreadsInfiniteQueryKey = (
  options?: Options<ListAgentThreadsData>
): QueryKey<Options<ListAgentThreadsData>> => createQueryKey("listAgentThreads", options, true)

/**
 * List agent threads
 */
export const listAgentThreadsInfiniteOptions = (options?: Options<ListAgentThreadsData>) =>
  infiniteQueryOptions<
    ListAgentThreadsResponse,
    ListAgentThreadsError,
    InfiniteData<ListAgentThreadsResponse>,
    QueryKey<Options<ListAgentThreadsData>>,
    string | Pick<QueryKey<Options<ListAgentThreadsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAgentThreadsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAgentThreads({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAgentThreadsInfiniteQueryKey(options),
    }
  )

/**
 * Create an agent thread
 */
export const createAgentThreadMutation = (
  options?: Partial<Options<CreateAgentThreadData>>
): UseMutationOptions<
  CreateAgentThreadResponse,
  CreateAgentThreadError,
  Options<CreateAgentThreadData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateAgentThreadResponse,
    CreateAgentThreadError,
    Options<CreateAgentThreadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAgentThread({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAgentThreadQueryKey = (options: Options<GetAgentThreadData>) =>
  createQueryKey("getAgentThread", options)

/**
 * Get agent thread
 */
export const getAgentThreadOptions = (options: Options<GetAgentThreadData>) =>
  queryOptions<
    GetAgentThreadResponse,
    GetAgentThreadError,
    GetAgentThreadResponse,
    ReturnType<typeof getAgentThreadQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAgentThread({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAgentThreadQueryKey(options),
  })

/**
 * Explicitly recreate an unavailable or uncertain workspace without deleting its previous state
 */
export const recreateAgentThreadSandboxMutation = (
  options?: Partial<Options<RecreateAgentThreadSandboxData>>
): UseMutationOptions<
  RecreateAgentThreadSandboxResponse,
  RecreateAgentThreadSandboxError,
  Options<RecreateAgentThreadSandboxData>
> => {
  const mutationOptions: UseMutationOptions<
    RecreateAgentThreadSandboxResponse,
    RecreateAgentThreadSandboxError,
    Options<RecreateAgentThreadSandboxData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await recreateAgentThreadSandbox({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAgentThreadMessagesQueryKey = (options: Options<ListAgentThreadMessagesData>) =>
  createQueryKey("listAgentThreadMessages", options)

/**
 * List agent thread messages
 */
export const listAgentThreadMessagesOptions = (options: Options<ListAgentThreadMessagesData>) =>
  queryOptions<
    ListAgentThreadMessagesResponse,
    ListAgentThreadMessagesError,
    ListAgentThreadMessagesResponse,
    ReturnType<typeof listAgentThreadMessagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAgentThreadMessages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAgentThreadMessagesQueryKey(options),
  })

export const listAgentThreadMessagesInfiniteQueryKey = (
  options: Options<ListAgentThreadMessagesData>
): QueryKey<Options<ListAgentThreadMessagesData>> =>
  createQueryKey("listAgentThreadMessages", options, true)

/**
 * List agent thread messages
 */
export const listAgentThreadMessagesInfiniteOptions = (
  options: Options<ListAgentThreadMessagesData>
) =>
  infiniteQueryOptions<
    ListAgentThreadMessagesResponse,
    ListAgentThreadMessagesError,
    InfiniteData<ListAgentThreadMessagesResponse>,
    QueryKey<Options<ListAgentThreadMessagesData>>,
    | string
    | Pick<QueryKey<Options<ListAgentThreadMessagesData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAgentThreadMessagesData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAgentThreadMessages({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAgentThreadMessagesInfiniteQueryKey(options),
    }
  )

/**
 * Post an agent thread message
 */
export const postAgentThreadMessageMutation = (
  options?: Partial<Options<PostAgentThreadMessageData>>
): UseMutationOptions<
  PostAgentThreadMessageResponse,
  PostAgentThreadMessageError,
  Options<PostAgentThreadMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    PostAgentThreadMessageResponse,
    PostAgentThreadMessageError,
    Options<PostAgentThreadMessageData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await postAgentThreadMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAgentMessageFileContentQueryKey = (
  options: Options<GetAgentMessageFileContentData>
) => createQueryKey("getAgentMessageFileContent", options)

/**
 * Get agent message file content
 */
export const getAgentMessageFileContentOptions = (
  options: Options<GetAgentMessageFileContentData>
) =>
  queryOptions<
    GetAgentMessageFileContentResponse,
    GetAgentMessageFileContentError,
    GetAgentMessageFileContentResponse,
    ReturnType<typeof getAgentMessageFileContentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAgentMessageFileContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAgentMessageFileContentQueryKey(options),
  })

/**
 * Cancel an agent thread's active run
 */
export const cancelAgentRunMutation = (
  options?: Partial<Options<CancelAgentRunData>>
): UseMutationOptions<CancelAgentRunResponse, CancelAgentRunError, Options<CancelAgentRunData>> => {
  const mutationOptions: UseMutationOptions<
    CancelAgentRunResponse,
    CancelAgentRunError,
    Options<CancelAgentRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await cancelAgentRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Retry a failed agent run
 */
export const retryAgentRunMutation = (
  options?: Partial<Options<RetryAgentRunData>>
): UseMutationOptions<RetryAgentRunResponse, RetryAgentRunError, Options<RetryAgentRunData>> => {
  const mutationOptions: UseMutationOptions<
    RetryAgentRunResponse,
    RetryAgentRunError,
    Options<RetryAgentRunData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await retryAgentRun({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAgentThreadRunsQueryKey = (options: Options<ListAgentThreadRunsData>) =>
  createQueryKey("listAgentThreadRuns", options)

/**
 * List an agent thread's runs
 */
export const listAgentThreadRunsOptions = (options: Options<ListAgentThreadRunsData>) =>
  queryOptions<
    ListAgentThreadRunsResponse,
    ListAgentThreadRunsError,
    ListAgentThreadRunsResponse,
    ReturnType<typeof listAgentThreadRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAgentThreadRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAgentThreadRunsQueryKey(options),
  })

export const listAgentThreadRunsInfiniteQueryKey = (
  options: Options<ListAgentThreadRunsData>
): QueryKey<Options<ListAgentThreadRunsData>> =>
  createQueryKey("listAgentThreadRuns", options, true)

/**
 * List an agent thread's runs
 */
export const listAgentThreadRunsInfiniteOptions = (options: Options<ListAgentThreadRunsData>) =>
  infiniteQueryOptions<
    ListAgentThreadRunsResponse,
    ListAgentThreadRunsError,
    InfiniteData<ListAgentThreadRunsResponse>,
    QueryKey<Options<ListAgentThreadRunsData>>,
    | string
    | Pick<QueryKey<Options<ListAgentThreadRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListAgentThreadRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAgentThreadRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAgentThreadRunsInfiniteQueryKey(options),
    }
  )

export const getAgentRunQueryKey = (options: Options<GetAgentRunData>) =>
  createQueryKey("getAgentRun", options)

/**
 * Get agent run
 */
export const getAgentRunOptions = (options: Options<GetAgentRunData>) =>
  queryOptions<
    GetAgentRunResponse,
    GetAgentRunError,
    GetAgentRunResponse,
    ReturnType<typeof getAgentRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAgentRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAgentRunQueryKey(options),
  })

export const listModelsQueryKey = (options?: Options<ListModelsData>) =>
  createQueryKey("listModels", options)

/**
 * List the project model catalog
 */
export const listModelsOptions = (options?: Options<ListModelsData>) =>
  queryOptions<
    ListModelsResponse,
    DefaultError,
    ListModelsResponse,
    ReturnType<typeof listModelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listModels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listModelsQueryKey(options),
  })

/**
 * Remove object link
 */
export const removeObjectLinkMutation = (
  options?: Partial<Options<RemoveObjectLinkData>>
): UseMutationOptions<
  RemoveObjectLinkResponse,
  RemoveObjectLinkError,
  Options<RemoveObjectLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveObjectLinkResponse,
    RemoveObjectLinkError,
    Options<RemoveObjectLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeObjectLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Create or update object link
 */
export const upsertObjectLinkMutation = (
  options?: Partial<Options<UpsertObjectLinkData>>
): UseMutationOptions<
  UpsertObjectLinkResponse,
  UpsertObjectLinkError,
  Options<UpsertObjectLinkData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertObjectLinkResponse,
    UpsertObjectLinkError,
    Options<UpsertObjectLinkData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertObjectLink({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Append telemetry point
 */
export const appendTelemetryMutation = (
  options?: Partial<Options<AppendTelemetryData>>
): UseMutationOptions<
  AppendTelemetryResponse,
  AppendTelemetryError,
  Options<AppendTelemetryData>
> => {
  const mutationOptions: UseMutationOptions<
    AppendTelemetryResponse,
    AppendTelemetryError,
    Options<AppendTelemetryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await appendTelemetry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Get bulk telemetry history
 */
export const getBulkTelemetryHistoryMutation = (
  options?: Partial<Options<GetBulkTelemetryHistoryData>>
): UseMutationOptions<
  GetBulkTelemetryHistoryResponse,
  GetBulkTelemetryHistoryError,
  Options<GetBulkTelemetryHistoryData>
> => {
  const mutationOptions: UseMutationOptions<
    GetBulkTelemetryHistoryResponse,
    GetBulkTelemetryHistoryError,
    Options<GetBulkTelemetryHistoryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await getBulkTelemetryHistory({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getTelemetryHistoryQueryKey = (options: Options<GetTelemetryHistoryData>) =>
  createQueryKey("getTelemetryHistory", options)

/**
 * Get telemetry history
 */
export const getTelemetryHistoryOptions = (options: Options<GetTelemetryHistoryData>) =>
  queryOptions<
    GetTelemetryHistoryResponse,
    GetTelemetryHistoryError,
    GetTelemetryHistoryResponse,
    ReturnType<typeof getTelemetryHistoryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTelemetryHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTelemetryHistoryQueryKey(options),
  })

export const getLatestTelemetryQueryKey = (options: Options<GetLatestTelemetryData>) =>
  createQueryKey("getLatestTelemetry", options)

/**
 * Get latest telemetry point
 */
export const getLatestTelemetryOptions = (options: Options<GetLatestTelemetryData>) =>
  queryOptions<
    GetLatestTelemetryResponse,
    GetLatestTelemetryError,
    GetLatestTelemetryResponse,
    ReturnType<typeof getLatestTelemetryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLatestTelemetry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLatestTelemetryQueryKey(options),
  })

export const listEventsQueryKey = (options?: Options<ListEventsData>) =>
  createQueryKey("listEvents", options)

/**
 * Read domain events
 */
export const listEventsOptions = (options?: Options<ListEventsData>) =>
  queryOptions<
    ListEventsResponse,
    ListEventsError,
    ListEventsResponse,
    ReturnType<typeof listEventsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listEventsQueryKey(options),
  })

export const listLogsQueryKey = (options?: Options<ListLogsData>) =>
  createQueryKey("listLogs", options)

/**
 * Read run logs
 */
export const listLogsOptions = (options?: Options<ListLogsData>) =>
  queryOptions<
    ListLogsResponse,
    ListLogsError,
    ListLogsResponse,
    ReturnType<typeof listLogsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLogs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLogsQueryKey(options),
  })

export const listProjectionsQueryKey = (options?: Options<ListProjectionsData>) =>
  createQueryKey("listProjections", options)

/**
 * List all projection definitions
 */
export const listProjectionsOptions = (options?: Options<ListProjectionsData>) =>
  queryOptions<
    ListProjectionsResponse,
    DefaultError,
    ListProjectionsResponse,
    ReturnType<typeof listProjectionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectionsQueryKey(options),
  })

export const getProjectionQueryKey = (options: Options<GetProjectionData>) =>
  createQueryKey("getProjection", options)

/**
 * Get a projection definition by id
 */
export const getProjectionOptions = (options: Options<GetProjectionData>) =>
  queryOptions<
    GetProjectionResponse,
    GetProjectionError,
    GetProjectionResponse,
    ReturnType<typeof getProjectionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjection({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectionQueryKey(options),
  })

export const listProjectionRunsQueryKey = (options?: Options<ListProjectionRunsData>) =>
  createQueryKey("listProjectionRuns", options)

/**
 * List projection run history
 */
export const listProjectionRunsOptions = (options?: Options<ListProjectionRunsData>) =>
  queryOptions<
    ListProjectionRunsResponse,
    ListProjectionRunsError,
    ListProjectionRunsResponse,
    ReturnType<typeof listProjectionRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjectionRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectionRunsQueryKey(options),
  })

export const listProjectionRunsInfiniteQueryKey = (
  options?: Options<ListProjectionRunsData>
): QueryKey<Options<ListProjectionRunsData>> => createQueryKey("listProjectionRuns", options, true)

/**
 * List projection run history
 */
export const listProjectionRunsInfiniteOptions = (options?: Options<ListProjectionRunsData>) =>
  infiniteQueryOptions<
    ListProjectionRunsResponse,
    ListProjectionRunsError,
    InfiniteData<ListProjectionRunsResponse>,
    QueryKey<Options<ListProjectionRunsData>>,
    | string
    | Pick<QueryKey<Options<ListProjectionRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListProjectionRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listProjectionRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listProjectionRunsInfiniteQueryKey(options),
    }
  )

export const getProjectionRunQueryKey = (options: Options<GetProjectionRunData>) =>
  createQueryKey("getProjectionRun", options)

/**
 * Get a projection run by id
 */
export const getProjectionRunOptions = (options: Options<GetProjectionRunData>) =>
  queryOptions<
    GetProjectionRunResponse,
    GetProjectionRunError,
    GetProjectionRunResponse,
    ReturnType<typeof getProjectionRunQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectionRun({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectionRunQueryKey(options),
  })

export const listWebhookRunsQueryKey = (options?: Options<ListWebhookRunsData>) =>
  createQueryKey("listWebhookRuns", options)

/**
 * List webhook run history
 */
export const listWebhookRunsOptions = (options?: Options<ListWebhookRunsData>) =>
  queryOptions<
    ListWebhookRunsResponse,
    ListWebhookRunsError,
    ListWebhookRunsResponse,
    ReturnType<typeof listWebhookRunsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listWebhookRuns({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listWebhookRunsQueryKey(options),
  })

export const listWebhookRunsInfiniteQueryKey = (
  options?: Options<ListWebhookRunsData>
): QueryKey<Options<ListWebhookRunsData>> => createQueryKey("listWebhookRuns", options, true)

/**
 * List webhook run history
 */
export const listWebhookRunsInfiniteOptions = (options?: Options<ListWebhookRunsData>) =>
  infiniteQueryOptions<
    ListWebhookRunsResponse,
    ListWebhookRunsError,
    InfiniteData<ListWebhookRunsResponse>,
    QueryKey<Options<ListWebhookRunsData>>,
    string | Pick<QueryKey<Options<ListWebhookRunsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListWebhookRunsData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listWebhookRuns({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listWebhookRunsInfiniteQueryKey(options),
    }
  )
